import {Agent, request} from './base';
import { AffiliateKitItem } from 'models/affiliate-kit-item';

export class AffiliateKitItemAgent extends Agent<AffiliateKitItem> {
    constructor() {
        super(AffiliateKitItem, '/affiliate-kit');
    }

    sync = async () => {
        await request.post('/affiliate-kit/sync', {});
    };
}
